import React, { memo } from "react";
import { Sky } from "v2/components/shared";

const UnprotectedLayout = ({ children }: { children: React.ReactNode }) => {
	return <Sky>{children}</Sky>;
};

export default memo(UnprotectedLayout);
